import React, { Component } from "react";
import { get, put } from "../../../utills/API";
import "../../../assets/sass/admin/Coupon/EditCoupon.scss";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import { required } from "../../../utills/Validation";

class EditCoupon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category_id: "",
      brand_id: "",
      category_name: "",
      brand_name: "",
      guid: "",
      pin: '',
      amount: null,
      categoryArr: [],
      brandsArr: [],
      errors: {},
      expiry_date: "",
      is_active: true,
    };
  }

  validateAllInputs = () => {
    const errors = {
      categoryError: null,
      brandError: null,
      guidError: null,
      amountError: null,
    };
    const { category_id, brand_id, guid, amount, expiry_date } = this.state;

    errors.categoryError = required(category_id);
    errors.brandError = required(brand_id);
    errors.guidError = required(guid);
    errors.amountError = required(amount);
    if (errors.amountError === null && isNaN(amount)) {
      errors.amountError = "amount should only be a Number";
    }
    this.setState({ errors });
  };

  validityCheck = () => {
    const { category_id, brand_id, guid, amount, expiry_date } = this.state;
    let isValid =
      category_id === "" ||
      brand_id === "" ||
      guid === "" ||
      amount === null ||
      amount === "";
    return !isValid;
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleExpiryDate = (date) => {
    this.setState({ expiry_date: date });
  };

  editBrandCoupon = async (e) => {
    e.preventDefault();
    this.validateAllInputs();
    if (this.validityCheck()) {
      const {
        category_id,
        brand_id,
        guid,
        pin,
        amount,
        expiry_date,
        is_active,
      } = this.state;
      const { couponId } = this.props.match.params;
      const editBrandCouponData = {
        coupon: {
          brand_id,
          category_id,
          guid,
          pin_number: pin,
          amount,
          expiry_date,
          is_active,
        },
      };

      try {
        const { data } = await put(`coupons/${couponId}`, editBrandCouponData);
        if (data.status === 200) {
          this.props.history.push("/admin/coupons");
        } else {
          toast.error("Something Went Wrong!", { autoClose: 2000 });
        }
      } catch (e) {
        console.log("error", e);
      }
    } else {
      console.log("Enter valid Details");
    }
  };

  async componentDidMount() {
    const { couponId } = this.props.match.params;

    try {
      const { data } = await get(`coupons/${couponId}`);
      var {
        category_id,
        brand_id,
        guid,
        pin_number,
        amount,
        expiry_date,
        is_active,
      } = data.data.coupon;
    } catch (e) {
      console.log("error", e);
    }

    const categories = await get("categories");
    const brands = await get("brands");

    this.setState({
      categoryArr: categories.data.data.categories,
      brandsArr: brands.data.data.brands,
      category_id,
      brand_id,
      guid,
      pin: pin_number,
      amount,
      expiry_date: expiry_date ? new Date(expiry_date) : null,
      is_active,
    });
  }

  statusHandleChange = () => {
    this.setState({
      is_active: !this.state.is_active,
    });
  };

  render() {
    const {
      category_id,
      brand_id,
      guid,
      pin,
      amount,
      expiry_date,
      errors,
      is_active,
    } = this.state;
    const { handleChange, editBrandCoupon } = this;
    return (
      <div id="content" className="span9 brand-coupon-edit">
        <div className="row-fluid">
          <div className="block">
            <div className="navbar navbar-inner block-header">
              <div className="muted pull-left">Edit Brand Coupon</div>
            </div>
            <div className="cont">
              <div className="row add-coupon-main">
                <div className="col-md-12 main-row">
                  <div className="name">Category Name</div>
                  <div className="val">
                    <select
                      name="category_id"
                      value={category_id}
                      className="form-control"
                      onChange={handleChange}
                    >
                      <option value={""}>Select Category</option>
                      {this.state.categoryArr.map((catgory) => (
                        <option value={catgory.id}>{catgory.name}</option>
                      ))}
                    </select>
                    {errors.categoryError ? (
                      <p className="error-warning">{errors.categoryError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="name">Brand Name</div>
                  <div className="val">
                    <select
                      name="brand_id"
                      value={brand_id}
                      className="form-control"
                      onChange={handleChange}
                    >
                      <option value={""}>Select Brands</option>
                      {this.state.brandsArr.map((brand) => (
                        <option value={brand.id}>{brand.name}</option>
                      ))}
                    </select>
                    {errors.brandError ? (
                      <p className="error-warning">{errors.brandError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="name">Guid</div>
                  <div className="val">
                    <input
                      className="form-control"
                      type="text"
                      name="guid"
                      placeholder="Enter Guid"
                      value={guid}
                      onChange={handleChange}
                    />
                    {errors.guidError ? (
                      <p className="error-warning">{errors.guidError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="name">PIN</div>
                  <div className="val">
                    <input
                      className="form-control"
                      type="text"
                      name="pin"
                      placeholder="Enter Pin number"
                      value={pin}
                      onChange={handleChange}
                    />
                    {errors.pinError ? (
                      <p className="error-warning">{errors.pinError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="name">Amount</div>
                  <div className="val">
                    <input
                      className="form-control"
                      type="text"
                      name="amount"
                      placeholder="Enter Amount"
                      value={amount}
                      onChange={handleChange}
                    />
                    {errors.amountError ? (
                      <p className="error-warning">{errors.amountError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="name">Expiry Date</div>
                  <div className="val">
                    <DatePicker
                      className="form-control"
                      selected={expiry_date}
                      onChange={this.handleExpiryDate}
                    />
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="col-md-3">Active</div>
                  <div className="onoffswitch">
                    <input
                      type="checkbox"
                      name="isStatus"
                      checked={is_active}
                      onClick={(e) => this.statusHandleChange()}
                      className="onoffswitch-checkbox"
                      id={`isStatus`}
                    />
                    <label className="onoffswitch-label" for="isStatus">
                      <span className="onoffswitch-inner"></span>
                      <span className="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
                <div className="col-md-12 main-row">
                  <div className="action-center">
                    <button
                      onClick={editBrandCoupon}
                      className="btn btn-primary"
                    >
                      Edit Coupon
                    </button>
                    {/* <Link to="/admin/coupons" className="btn btn-primary">
                      Cancel
                    </Link> */}
                    <button
                      className="btn btn-primary"
                      onClick={() => this.props.history.goBack()}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditCoupon;
